import React, {
    useImperativeHandle,
    useRef,
    useEffect,
    forwardRef,
    useState
} from "react";
import { Modal } from "bootstrap";

const DeviceTypeSearchModal = forwardRef(({ submitSearchFormProp }, ref) => {

    const modalElem = useRef(null);
    const searchModal = useRef(null);

    const initialSearching = {
        search_like_name: "",
        search_is_child: ""
    };

    const [searchForm, setSearchForm] = useState(initialSearching);

    const searchFormLabel = {
        search_like_name: "Device Type : ",
        search_is_child: "Is Child : "
    };

    useImperativeHandle(ref, () => ({
        initModalHandler: () => {
            searchModal.current.show();
        },
        clearSearchForm: () => {
            setSearchForm(initialSearching);
        }
    }));

    useEffect(() => {
        modalElem.current = document.getElementById("deviceTypeSearchID");
        searchModal.current = new Modal(modalElem.current, {
            keyboard: false,
            backdrop: false
        });
        return () => searchModal.current?.dispose();
    }, []);

    const submitSearchForm = (e) => {
        e && e.preventDefault()
        let serachFormKeys = Object.keys(searchForm);
        let searchedElems = [];
        let searchParams = {};
        serachFormKeys.map((key) => {
            let label = searchFormLabel[key];
            let value = searchForm[key];
            if (value && value.toString().length > 0) {
                searchParams[key] = value;
                if (label) {
                    let show_val = value;

                    if (key == 'search_like_name') {
                        show_val = searchForm ? searchForm.search_like_name : '';
                    }
                    if (key === "search_is_child") {
                        show_val = value ;
                    }

                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });
        submitSearchFormProp(searchedElems, searchForm);
        console.log(searchForm);

        searchModal.current.hide();
    };



    const searchModalClose = () => {
        searchModal.current.hide();
    };

    return (
        <div className="modal fade" id="deviceTypeSearchID" tabIndex="-1" ref={modalElem}>
            <div className="modal-dialog modal-md">
                <div className="modal-content">

                    <div className="modal-header">
                        <h5 className="modal-title">Device Type Search</h5>
                        <button className="btn-close" onClick={searchModalClose} />
                    </div>

                    <div className="modal-body">
                        <form onSubmit={submitSearchForm}>

                            {/* Device Type */}
                            <div className="row my-3 align-items-center">
                                <label className="col-sm-4 col-form-label col-form-label-sm">
                                    Device Type
                                </label>
                                <div className="col-sm-8">
                                    <input
                                        name="search_like_name"
                                        type="text"
                                        value={searchForm.search_like_name}
                                        className="form-control form-control-sm"
                                        onChange={(e) =>
                                            setSearchForm(p => ({ ...p, search_like_name: e.target.value }))
                                        }
                                        placeholder="Enter Device Type"
                                    />
                                </div>
                            </div>

                            <div className="row my-3 align-items-center">
                                <label className="col-sm-4 col-form-label col-form-label-sm">
                                    Is Child
                                </label>
                                <div className="col-sm-8 d-flex gap-3">

                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            id="isChildYes"
                                            name="search_is_child"
                                            value="Y"
                                            checked={searchForm.search_is_child === "Y"}
                                            onChange={(e) =>
                                                setSearchForm(p => ({ ...p, search_is_child: e.target.value }))
                                            }
                                        />
                                        <label className="form-check-label" htmlFor="isChildYes">Yes</label>
                                    </div>

                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            id="isChildNo"
                                            name="search_is_child"
                                            value="N"
                                            checked={searchForm.search_is_child === "N"}
                                            onChange={(e) =>
                                                setSearchForm(p => ({ ...p, search_is_child: e.target.value }))
                                            }
                                        />
                                        <label className="form-check-label" htmlFor="isChildNo">No</label>
                                    </div>

                                </div>
                            </div>

                            <div className="modal-footer px-0">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={searchModalClose}
                                >
                                    Close
                                </button>
                                <button type="submit" className="btn btn-primary">
                                    Search
                                </button>
                            </div>

                        </form>
                    </div>

                </div>
            </div>
        </div>
    );
});

export default DeviceTypeSearchModal;
